import React from "react";

export const TokenFile: React.FC = () => {
  const cardClass =
    "p-4 rounded-xl border border-white/[0.08] bg-white/[0.04] backdrop-blur-[6px]";

  return (
    <div>
      <h1 className="text-2xl font-bold text-web-primary">
        Generate Access Token
      </h1>

      <p className="mt-1 text-sm text-white/70">
        Follow the steps below to generate your API access token. This token is
        required for all authenticated API requests.
      </p>

      <div className="mt-6 space-y-4">
        <div className={cardClass}>
          <p className="mb-1 text-sm font-semibold text-white">
            Step 1 — Go to Developer Section
          </p>
          <p className="text-xs text-white/70">
            Navigate to the Developer section from your dashboard.
          </p>
        </div>

        <div className={cardClass}>
          <p className="mb-1 text-sm font-semibold text-white">
            Step 2 — Register Company
          </p>
          <p className="text-xs text-white/70">
            Click on <strong>Register Company</strong> and fill in the required
            details:
          </p>

          <ul className="mt-2 list-disc space-y-1 pl-5 text-xs text-white/70">
            <li>Company Name</li>
            <li>Website URL</li>
          </ul>
        </div>

        <div className={cardClass}>
          <p className="mb-1 text-sm font-semibold text-white">
            Step 3 — Approval Time
          </p>
          <p className="text-xs text-white/70">
            Your company registration will be reviewed and approved within{" "}
            <strong className="text-web-primary">~12 hours</strong>.
          </p>
        </div>

        <div className={cardClass}>
          <p className="mb-1 text-sm font-semibold text-white">
            Step 4 — View Company Details
          </p>
          <p className="text-xs text-white/70">
            Once approved, go to the <strong>Company List</strong> and click on{" "}
            <strong>View Details</strong>.
          </p>
        </div>

        <div className={cardClass}>
          <p className="mb-1 text-sm font-semibold text-white">
            Step 5 — Generate Token
          </p>
          <p className="text-xs text-white/70">
            Click on <strong>Generate Token</strong> to create your API token.
          </p>
        </div>

        <div className={cardClass}>
          <p className="mb-1 text-sm font-semibold text-white">
            Step 6 — Use Token
          </p>

          <p className="text-xs text-white/70">
            Use this token in your API requests as a Bearer token:
          </p>

          <div className="mt-3 rounded-lg border border-white/[0.08] bg-black/20 p-3 font-mono text-xs text-web-primary">
            Authorization: Bearer YOUR_ACCESS_TOKEN
          </div>
        </div>
      </div>

      <div className="mt-6 rounded-xl border border-web-primary/20 bg-web-primary/10 p-4 text-sm text-white">
        <span className="font-semibold text-web-primary">📋 Note:</span> Keep
        your token secure. Do not expose it in frontend code or public
        repositories.
      </div>
    </div>
  );
};
